import React, { useState } from 'react'
import { Header, Modal, Button, Icon, Card, Grid, Label, Divider, Table } from 'semantic-ui-react'
import ShowMoreText from "react-show-more-text";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from 'swiper/react';

import "./AccommodationRooms.css"

const rooms = [
    {
        title: "پذیرایی",
        floor: "طبقه همکف",
        info: "بدون تخت خواب",
        facilities: {
            CoolingSystem: "اسپلیت",
            HeatingSystem: "هیتر برقی",
            ClothesHanger: true,
            Window: true,
            Curtain: true,
            Bed: false
        },

    },
    {
        title: "اتاق خواب ۱",
        floor: "طبقه همکف",
        info: "۳ تخت یک‌ نفره",
        facilities: {
            CoolingSystem: false,
            HeatingSystem: "هیتر برقی",
            ClothesHanger: true,
            Window: true,
            Curtain: true,
            Bed: "۳ تخت یک‌ نفره"
        },
    },
    {
        title: "اتاق خواب ۲",
        floor: "طبقه اول",
        info: "۱ تخت دو نفره",
        facilities: {
            CoolingSystem: "اسپلیت",
            HeatingSystem: "هیتر برقی",
            ClothesHanger: true,
            Window: true,
            Curtain: true,
            Bed: "۱ تخت دو نفره"
        },
    },
    {
        title: "اتاق خواب ۱",
        floor: "طبقه همکف",
        info: "۳ تخت یک‌ نفره",
        facilities: {
            CoolingSystem: "اسپلیت",
            HeatingSystem: "هیتر برقی",
            ClothesHanger: false,
            Window: true,
            Curtain: true,
            Bed: "۳ تخت یک‌ نفره"
        },
    }
]
const AccommodationRooms = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<>
        <Header as='h3'>{t("property:RoomInfo")}</Header>
        <p>{t("property:RoomInfoText")}</p>
        <Swiper
            spaceBetween={50}
            slidesPerView={3}
        >
            {
                rooms.map((item, index) => {
                    return <SwiperSlide key={index} className="m-1">
                        <Card>
                            <Card.Content>
                                <Card.Header>{item.title}</Card.Header>
                                <Card.Description>
                                    {item.info}
                                </Card.Description>
                                <Card.Meta className="m-05-t"><Label basic color="blue">{item.floor}</Label></Card.Meta>

                            </Card.Content>
                        </Card>
                    </SwiperSlide>
                })
            }


        </Swiper>


        <Modal
            size="small"
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={<Button size="big" className="m-1-t m-1-b  p-1-t p-1-b p-0 bg-transparent text-blue" >{t("property:RoomDetails")}
                <Icon name="chevron right" /></Button>}>
            <Modal.Header>{t("property:RoomDetails")}</Modal.Header>
            <Modal.Content scrolling>
                <Modal.Description>
                    <Grid columns={1}>
                        {
                            rooms.map((item, index) => {
                                return <Grid.Column>
                                    <Header as='h2'>{item.title}</Header>

                                    <Grid columns={2}>
                                        <Grid.Row>
                                            <Grid.Column width={4}>
                                                <Header className="m-05-t m-05-b" as='h3'>
                                                    {t("property:Position")} :
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column width={12}>
                                                <p className="m-05">
                                                    {item.floor}
                                                </p>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={4}>
                                                <Header className="m-05-t m-05-b" as='h3'>
                                                    {t("property:RoomFacilities")} :
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column width={12}>
                                                <Table className="w-100" basic='very' celled collapsing>
                                                    <Table.Body >
                                                        {

                                                            Object.keys(item.facilities).map(function (key, keyIndex) {
                                                                return <Table.Row textAlign="center">
                                                                    <Table.Cell>
                                                                        <Header as='h4'>
                                                                            <Header.Content>
                                                                                {t(`property:${key}`)}
                                                                            </Header.Content>
                                                                        </Header>
                                                                    </Table.Cell>
                                                                    <Table.Cell>{item.facilities[key] ? (item.facilities[key] === true ? <Icon color="green" name="check" /> : item.facilities[key]) : <Icon color="red" name="close" />}</Table.Cell>
                                                                </Table.Row>
                                                            })
                                                        }
                                                    </Table.Body>
                                                </Table>
                                            </Grid.Column>
                                        </Grid.Row>

                                    </Grid>
                                    <Divider />
                                </Grid.Column>
                            })
                        }
                    </Grid>

                </Modal.Description>
            </Modal.Content>
        </Modal>
    </>
    )
}
export default AccommodationRooms